import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const EmergencyNotificationDetailPage = lazy(
  () =>
    import('@/pages/emergency-notifications/ui/EmergencyNotificationDetailPage'),
)

export const Route = createFileRoute(
  '/_protected/laboratory/notifications/$notificationId',
)({
  component: () => (
    <Suspense fallback={<Loader />}>
      <EmergencyNotificationDetailPage />
    </Suspense>
  ),
})
